module.exports = __webpack_public_path__ + "img/support-3.fdeb8247.png";